<template>
	<div>
	</div>
</template>

<script>
	import login from "../services/login.js";
	import users from "../services/users.js";

	export default {
		nam: "login_admin",
		data() {
			return {
			};
		},
		methods: {
		},
		async mounted()
		{
			let jwt = this.$route.query.jwt;
			console.log(jwt);
			this.$store.commit("setJwt", jwt);

			var response = await users.getSelf(true);
			this.$store.commit("setUser", response.user);						

			this.$emit("loginSuccess");
			this.$router.push({ name: "main" });
		}
	};
</script>

<style>
	.baground {
		margin-right: 250px;
	}
	.logo {
		text-align: center;
		margin-left: auto;
		margin-right: auto;
		max-width: 100%;
		max-height: 100%;
		display: block;
	}
</style>
